import { numberToPrettyString } from '@cian/utils';
import { NBSP } from '../../constants/symbols';

export const formatNumber = (value: number): string => {
  return numberToPrettyString(value).replace(/ /g, NBSP);
};
